define('drops/ganttChart/ganttChart',[
    'jquery',
    'globalize',
    'lq/drop',
    'lq/style',
    'lq/constants'
], function ($, globalize, Drop, Style, constants) {
    'use strict';

    var defaults = {
        data: {
            dependencyArrowRemoverEnabled: true
        }
    };

    function GanttChart(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        Style.renderStyles(this);
    };

    Drop.extend(GanttChart, Drop);

    GanttChart.typeName = 'GanttChart';

    GanttChart.prototype.preRender = function () {
        this.GanttChartComponent = null;

        this.applyPosition();

        var self = this;

        this.piping.datasources.registerDatasourceListener(
            this.data.tasksDataSource,
            function (data) {
                self.taskData = data.Results.map(function(result) {
                    return {
                        id: result[self.data.taskId],
                        name: result[self.data.taskName],
                        start: result[self.data.taskStart].substring(0, 10),
                        end: result[self.data.taskEnd].substring(0, 10),
                        position: result[self.data.taskPosition]
                    };
                });

                if (self.GanttChartComponent) {
                    self.GanttChartComponent.setTasksL(self.taskData);
                }
            });

        this.piping.datasources.registerDatasourceListener(
            this.data.dependenciesDataSource,
            function (data) {
                self.dependencyData = data.Results.map(function(result) {
                    return {
                        id: result[self.data.dependencyId],
                        fromTaskId: result[self.data.dependencyFromTaskId],
                        toTaskId: result[self.data.dependencyToTaskId]
                    };
                });

                if (self.GanttChartComponent) {
                    self.GanttChartComponent.setDependenciesL(self.dependencyData);
                }
            });

        FrontendModules.load('ganttChart', true)
            .then(this.showComponent.bind(this));
    };

    GanttChart.prototype.showComponent = function (GanttChartComponentRendered) {
        var self = this;

        GanttChartComponentRendered.default({
            changeTask: function (taskId, newStartDate, newEndDate) {
                self.piping.parameters.locals.setValue(self.data.taskIdParameter, taskId);
                self.piping.parameters.locals.setValue(self.data.taskStartParameter, globalize.format(new Date(newStartDate), constants.licquidDateFormat));
                self.piping.parameters.locals.setValue(self.data.taskEndParameter, globalize.format(new Date(newEndDate), constants.licquidDateFormat));
                
                self.triggerEventIfEnabled('taskChanged');
            },
            taskClicked: function (taskId, startDate, endDate) {
                self.piping.parameters.locals.setValue(self.data.taskIdParameter, taskId);
                self.piping.parameters.locals.setValue(self.data.taskStartParameter, globalize.format(new Date(startDate), constants.licquidDateFormat));
                self.piping.parameters.locals.setValue(self.data.taskEndParameter, globalize.format(new Date(endDate), constants.licquidDateFormat));
                
                self.triggerEventIfEnabled('taskClicked');
            },
            taskHovered: function (taskId, startDate, endDate) {
                self.piping.parameters.locals.setValue(self.data.taskIdParameter, taskId);
                self.piping.parameters.locals.setValue(self.data.taskStartParameter, globalize.format(new Date(startDate), constants.licquidDateFormat));
                self.piping.parameters.locals.setValue(self.data.taskEndParameter, globalize.format(new Date(endDate), constants.licquidDateFormat));
                
                self.triggerEventIfEnabled('taskHovered');
            },
            addDependency: function (dependencyId, fromTaskId, toTaskId) {
                self.piping.parameters.locals.setValue(self.data.dependencyIdParameter, dependencyId);
                self.piping.parameters.locals.setValue(self.data.dependencyFromTaskIdParameter, fromTaskId);
                self.piping.parameters.locals.setValue(self.data.dependencyToTaskIdParameter, toTaskId);
                
                self.triggerEventIfEnabled('dependencyAdded');
            },
            deleteDependency: function (dependencyId) {
                self.piping.parameters.locals.setValue(self.data.dependencyIdParameter, dependencyId);

                self.triggerEventIfEnabled('dependencyDeleted');
            },
            dependencyClicked: function (dependencyId, fromTaskId, toTaskId) {
                self.piping.parameters.locals.setValue(self.data.dependencyIdParameter, dependencyId);
                self.piping.parameters.locals.setValue(self.data.dependencyFromTaskIdParameter, fromTaskId);
                self.piping.parameters.locals.setValue(self.data.dependencyToTaskIdParameter, toTaskId);

                self.triggerEventIfEnabled('dependencyClicked');
            },
            
        }, this.$element.get(0));

        if (this.taskData) {
            GanttChartComponentRendered.setTasksL(this.taskData);
        }
        if (this.dependencyData) {
            GanttChartComponentRendered.setDependenciesL(this.dependencyData);
        }

        GanttChartComponentRendered.configureGanttChart({
            cellWidth: this.data.cellWidth,
            cellHeight: this.data.cellHeight,
            barHeight: this.data.barHeight,
            toolbarHeight: this.data.toolbarHeight,
            dependencyArrowRemoverEnabled: this.data.dependencyArrowRemoverEnabled
        });

        this.GanttChartComponent = GanttChartComponentRendered;
    };

    return GanttChart;
});
